// count down 
(function(){
  $.fn.rvpCountDown = function( options ) {
    return this.each(function() { 
      new  $.rvpCountDown( this, options ); 
    });
   }
  $.rvpCountDown = function( obj, options ){
    this.options = $.extend({
        autoStart:true,
        LeadingZero:true,
        DisplayFormat:"<div>%%D%% Days</div><div>%%H%% Hours</div><div>%%M%% Minutes</div><div>%%S%% Seconds</div>",
        FinishMessage:"Expired",
        CountActive:true,
        TargetDate:null
    }, options || {} );
    if( this.options.TargetDate == null || this.options.TargetDate == '' ){
      return ;
    }
    this.timer  = null;
    this.element = obj;
    this.CountStepper = -1;
    this.CountStepper = Math.ceil(this.CountStepper);
    this.SetTimeOutPeriod = (Math.abs(this.CountStepper)-1)*1000 + 990;
    var dthen = new Date(this.options.TargetDate);
    var dnow = new Date();
    if( this.CountStepper > 0 ) {
      ddiff = new Date(dnow-dthen);
    }
    else {
       ddiff = new Date(dthen-dnow);
    }
    gsecs = Math.floor(ddiff.valueOf()/1000); 
    this.CountBack(gsecs, this);

  };
   $.rvpCountDown.fn =  $.rvpCountDown.prototype;
     $.rvpCountDown.fn.extend =  $.rvpCountDown.extend = $.extend;
   $.rvpCountDown.fn.extend({
    calculateDate:function( secs, num1, num2 ){
        var s = ((Math.floor(secs/num1))%num2).toString();
        if ( this.options.LeadingZero && s.length < 2) {
          s = "0" + s;
        }
        return "<b>" + s + "</b>";
    },
    CountBack:function( secs, self ){
       if (secs < 0) {
        self.element.innerHTML = '<div class="lof-labelexpired"> '+self.options.FinishMessage+"</div>";
        return;
        }
        clearInterval(self.timer);
        DisplayStr = self.options.DisplayFormat.replace(/%%D%%/g, self.calculateDate( secs,86400,100000) );
        DisplayStr = DisplayStr.replace(/%%H%%/g, self.calculateDate(secs,3600,24));
        DisplayStr = DisplayStr.replace(/%%M%%/g, self.calculateDate(secs,60,60));
        DisplayStr = DisplayStr.replace(/%%S%%/g, self.calculateDate(secs,1,60));
        self.element.innerHTML = DisplayStr;
        if (self.options.CountActive) {
           self.timer = null;
         self.timer =  setTimeout( function(){
          self.CountBack((secs+self.CountStepper),self);      
        },( self.SetTimeOutPeriod ) );
       }
    }
          
  })
})(jQuery)

// end count down

$(document).ready(function() {
  "use strict";  
  responsiveResize();
  footerCollapse1();
  initStickyCartProductPage();

});

function initStickyCartProductPage() {
  if ($('.Product-all-detail .product-sticky').length || $('.Product-all-detail .product-sticky').length) {
    var lastScrollTop = 0;
    var navbarHeight = $('.product-sticky').outerHeight();
    // on scroll, let the interval function know the user has scrolled
    $(window).scroll(function(event){
    
        var st = $(this).scrollTop();

        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight){
          // Scroll Down
          $('.product-sticky').removeClass('stickycart').addClass('stickycart');
        } else {
          // Scroll Up
          if (st > navbarHeight) {
            if(st + $(window).height() < $(document).height()) {
              $('.product-sticky').removeClass('nav-up').addClass('stickycart');
            }
          }
          if (st == 0) {
            $('.product-sticky').removeClass('nav-up').removeClass('stickycart');
          }
        }

        lastScrollTop = st;
      
    });
  }
}


function accordionFooter(status)
  {
    if(status == 'enable')
    {
     $('.mobile-collapse_title').on('click', function(e){
      e.stopPropagation();
      $(this).toggleClass('active').parent().find('.mobile-collapse_content').stop().slideToggle('medium');
      e.preventDefault();
    })
     $('.mobile-collapse_title').find('.mobile-collapse_content').slideUp('medium');
   }
   else
   {
    $('.mobile-collapse_content').removeClass('active').off().parent().find('.mobile-collapse_content').removeAttr('style').slideDown('medium');
  }
}

function responsiveResize()
{
        if ($(window).width() <= 991 ) {
                // accordion('enable');
                accordionFooter('enable');
        } else if ($(window).width() >= 992) {
                // accordion('disable');
                accordionFooter('disable');
        }
}

function footerCollapse1()
{
  $('.Filter-inner-block .rv-downi').on('click', function(e){
    e.stopPropagation();
    $(this).toggleClass('active').parent().find('.level1').stop().slideToggle('medium');
    e.preventDefault();
  })
  $('.Filter-inner-block .rv-downi').find('.level1').slideUp('medium');
}

$(document)
.on('shopify:section:load', eventHandler)
.ready(function() { $('[data-sectionname]').each(function(){ $(this).initSection() }); });

function eventHandler(e) {
  $('#' + e.target.id).find('[data-sectionname]').initSection();
}
$.fn.initSection = function(){
  var _ = this;
  var n = _.data('sectionname');
  switch (n) {
    case ("Product-tab-view"): _.find('.product-grid-slider').initSlick_product(); break;
      
    case ("bottom_blog"): _.find('.rvsmartblog-carousel').initSlick_bmblog(); break;
      
    case ("slider_withbanners"): _.find('.slick-slider-content').dotSlick(); break;
      
    case ("collection-list"): _.find('.rvcollection-list').initSlick_collection(); break;

    case ("Testimonial-section"): _.find('.testimonial-slider').initSlick_testimonial(); break;

    case ("header_service"): _.find('#rvheader_service_carousel').header_service(); break;

    case ("header-mega-product"): _.find('.header-menu-product').initSlick_headermenu_product(); break;

    default: break;
  }
}

$.fn.initSlick_headermenu_product = function() {
  this.slick({
    arrows:false,
    prevArrow: '<i class="fa fa-angle-left"></i>',
    nextArrow: '<i class="fa fa-angle-right"></i>',
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
  });
}

$.fn.header_service = function() {
  this.slick({
    arrows:false,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]

  });
}

$.fn.initSlick_testimonial = function() {
  this.slick({
    arrows:false,
    dots: false,
    prevArrow: '<i class="fa fa-angle-left"></i>',
    nextArrow: '<i class="fa fa-angle-right"></i>',
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
  });
}


$.fn.initSlick_bmblog = function() {
  this.slick({
    arrows:false,
     prevArrow: '<i class="fa fa-angle-left"></i>',
    nextArrow: '<i class="fa fa-angle-right"></i>',
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
  });
}


$.fn.initSlick_collection = function() {
  this.slick({
    arrows:true,
    slidesToShow: 3,
    rows: 1,
    prevArrow: '<i class="fa fa-angle-left"></i>',
    nextArrow: '<i class="fa fa-angle-right"></i>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }]
  });
}

$.fn.initSlick_product = function() {
  this.slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   arrows: false,
   dots: false,
   rows: 2,
   fade: false,
   prevArrow: '<i class="fa fa-angle-left"></i>',
   nextArrow: '<i class="fa fa-angle-right"></i>',
   pauseOnHover: true,
     responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }]
  });
}

$.fn.initSlick = function(md, sm, xs) {
  this.slick({
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
  });
}

$.fn.dotSlick = function(){
  this.slick({
    infinite: true,
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<i class="fa fa-angle-left"></i>',
    nextArrow: '<i class="fa fa-angle-right"></i>',
  });
}




